<template>
  <div>
    <v-card elevation="1" class="pa-8">
      <h2 class="page-title">
        ติดตามสถานะ
      </h2>
      <v-row class="mt-5 mb-7" id="sectionSearch">
        <v-col cols="12" sm="3">
          <v-select
            v-model="project_type"
            label="ประเภทคำเสนอ"
            :items="project_type_item"
            item-text="name"
            item-value="id"
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-dialog
            ref="dialog_start"
            v-model="modal_start"
            :return-value.sync="date_start"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_start"
                label="วันที่เริ่มต้น"
                append-icon="far fa-calendar-alt"
                readonly
                v-bind="attrs"
                v-on="on"
                color="purple lighten-2"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_start"
              scrollable
              color="purple"
              locale="th-th"
              :max="date_end"
            >
              <v-spacer></v-spacer>
              <v-btn
                class="ppim-btn"
                color="grey"
                text
                @click="modal_start = false"
                >ยกเลิก</v-btn
              >
              <v-btn
                class="ppim-btn"
                color="purple lighten-2"
                dark
                depressed
                @click="$refs.dialog_start.save(date_start)"
                >ยืนยัน</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="3">
          <v-dialog
            ref="dialog_end"
            v-model="modal_end"
            :return-value.sync="date_end"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date_end"
                label="วันที่สิ้นสุด"
                append-icon="far fa-calendar-alt"
                readonly
                v-bind="attrs"
                v-on="on"
                color="purple lighten-2"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_end"
              scrollable
              color="purple"
              locale="th-th"
              :min="date_start"
            >
              <v-spacer></v-spacer>
              <v-btn
                class="ppim-btn"
                color="grey"
                text
                @click="modal_end = false"
                >ยกเลิก</v-btn
              >
              <v-btn
                class="ppim-btn"
                color="purple lighten-2"
                dark
                depressed
                @click="$refs.dialog_end.save(date_end)"
                >ยืนยัน</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field
            label="เลขที่คำเสนอขอขายไฟฟ้า"
            v-model="notification_no"
            color="purple lighten-2"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="text-center pa-0">
          <v-btn
            class="ppim-btn mr-2"
            color="purple darken-2"
            depressed
            dark
            @click="search"
            ><v-icon small left>fas fa-search</v-icon>ค้นหา</v-btn
          >
          <v-btn
            class="ppim-btn"
            color="purple lighten-2"
            depressed
            @click="clearFilter"
            dark
            >ล้างตัวกรอง</v-btn
          >
        </v-col>
      </v-row>
      <v-row id="sectionDataTable">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :sort-by="['create_date']"
            :sort-desc="[true]"
            :items="projects"
            :items-per-page="10"
            :loading="is_loading"
            loading-text="กำลังดึงข้อมูล ..."
            mobile-breakpoint="xs"
          >
            <template v-slot:progress>
              <v-col cols="12" class="text-center">
                <v-progress-circular
                  :size="60"
                  :width="6"
                  color="purple"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </template>
            <template v-slot:item.create_date="{ item }">
              <span>
                {{ getDate(item.create_date) }}
              </span>
            </template>
            <template v-slot:item.paid_status="{ item }">
              {{ paymentStatusText(item.paid_status) }}
            </template>
            <template v-slot:item.request_status="{ item }">
              {{ requestStatusText(item.request_status) }}
            </template>
            <template v-slot:item.project_detail="{ item }">
              <router-link
                :to="{
                  name: 'request-eco-view',
                  params: {
                    pid: item.project_code,
                    type: item.project_type,
                    rid: item.notification_no
                  }
                }"
                style="text-decoration: none;"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="purple darken-2"
                      elevation="0"
                      fab
                      dark
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>fas fa-file-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>คลิกดูรายละเอียด</span>
                </v-tooltip>
              </router-link>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <dialog-alert
      v-model="dialog_alert.show"
      :type="dialog_alert.type"
      :title="dialog_alert.title"
      :message="dialog_alert.message"
    ></dialog-alert>
  </div>
</template>

<script>
import { _, DateTime, StatusText } from "@/plugins/app";
import { dialog_data, dialog_methods } from "@/helpers/dialog";
import DialogAlert from "@/components/DialogAlert";
import api from "@/plugins/axios";
import { mapState } from "vuex";

export default {
  props: ["noti"],
  components: {
    DialogAlert
  },
  data: () => ({
    date_start: null,
    modal_start: false,
    date_end: null,
    modal_end: false,
    notification_no: "",
    project_type: "",
    headers: [
      { text: "รหัสโครงการ", value: "project_code" },
      { text: "เลขที่คำเสนอ", value: "notification_no", align: "center" },
      {
        text: "วันที่สร้างคำเสนอ",
        value: "create_date",
        align: "center"
      },
      { text: "สถานะการชำระเงิน", value: "paid_status", align: "center" },
      { text: "สถานะคำเสนอ", value: "request_status", align: "center" },
      {
        text: "รายละเอียด",
        value: "project_detail",
        align: "center",
        sortable: false
      }
    ],
    projects: [],
    projectStatus: ["ปิด", "เปิด"],
    is_loading: true,

    ...dialog_data
  }),
  methods: {
    getData: function() {
      this.is_loading = true;
      this.projects = [];

      let date_start =
        this.date_start == null
          ? DateTime.fromISO("1990-01-01").toISO()
          : DateTime.fromISO(this.date_start).toISO();
      let date_end =
        this.date_end == null
          ? null
          : DateTime.fromISO(this.date_end)
              .endOf("day")
              .toISO();
      let notification_no = this.notification_no;

      api
        .get("/request/eco", {
          params: {
            start_date: date_start,
            end_date: date_end,
            notification_no: notification_no,
            project_type: this.project_type
          }
        })
        .then(response => {
          this.projects = [];
          _.forEach(response.data, request => {
            this.projects.push(request.request);
          });
          this.is_loading = false;
        });
    },
    search: function() {
      this.getData();
    },
    clearFilter: function() {
      this.date_start = null;
      this.date_end = null;
      this.notification_no = "";
    },
    showDetail(projectCode) {
      alert(projectCode);
    },
    getDate(set_date) {
      let date = DateTime.fromISO(set_date).toFormat("yyyy-MM-dd HH:mm:ss");
      return date;
    },
    // getPaymentStatus(status){
    //   if(status == 10){
    //     return "รอการวางเงินค้ำประกัน";
    //   }else if(status == 20){
    //     return "วางหลักประกันแล้ว";
    //   }else if(status == 30){
    //     return "คืนหลักประกันแล้ว";
    //   }else if(status == 40){
    //     return "ยึดหลักประกัน";
    //   }
    // },
    // getRequestStatus(status){
    //   if(status == 10){
    //     return "รอการชำระเงินและยื่นเอกสาร";
    //   }else if(status == 20){
    //     return "รอการยื่นเอกสาร";
    //   }else if(status == 30){
    //     return "ยื่นเอกสารแล้ว";
    //   }else if(status == 40){
    //     return "รอพิจารณาเทคนิค";
    //   }else if(status == 50){
    //     return "เอกสารไม่ครบถ้วน";
    //   }else if(status == 60){
    //     return "ผ่านการพิจารณาทางเทคนิค";
    //   }else if(status == 70){
    //     return "ไม่ผ่านการพิจารณาทางเทคนิค";
    //   }else if(status == 80){
    //     return "อุทธรณ์";
    //   }else if(status == 90){
    //     return "รอพิจารณาราคา";
    //   }else if(status == 100){
    //     return "ผ่านการพิจารณาราคา";
    //   }else if(status == 110){
    //     return "ไม่ผ่านการพิจารณาราคา";
    //   }
    // },

    ...dialog_methods,
    ...StatusText
  },
  computed: {
    project_type_item() {
      let item = [{ id: "", name: "ทั้งหมด" }];

      this.master_project_type.forEach(obj => item.push(obj));

      return item;
    },
    ...mapState({
      master_project_type: "project_type"
    })
  },
  created() {
    if (this.noti) {
      let message =
        'กรุณาตรวจสอบคำร้องเลขที่ <strong class="text-uppercase">' +
        this.noti +
        "</strong> ในรายการคำร้องของท่านเพื่อดำเนินการต่อ";
      this.showDialogAlert(true, "success", "ยื่นคำร้องเรียบร้อยแล้ว", message);
    }

    this.getData();
  }
};
</script>
